import * as React from "react";
import type { SVGProps } from "react";
const SvgBankNote03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.023 11.976 6 12m12-.024-.024.024M4.2 18h15.6a1.8 1.8 0 0 0 1.8-1.8V7.8A1.8 1.8 0 0 0 19.8 6H4.2a1.8 1.8 0 0 0-1.8 1.8v8.4A1.8 1.8 0 0 0 4.2 18m10.2-6a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0"
    />
  </svg>
);
export default SvgBankNote03;
